export class AuthModel {
  constructor(signedIn) {
    this.signedIn = signedIn === true || signedIn === 'true';
  }
}



// WEBPACK FOOTER //
// ./src/models/auth/AuthModel.js